function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import _ from 'lodash';
import { FileDrop as ReactFileDrop } from 'react-file-drop';
import FileDropHint from "./FileDropHint";
import { getBase64, retrieveImageFromClipboardAsBlob } from "../../../helpers/fileUtils";

class FileDrop extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      showFileDropHint: false
    });

    _defineProperty(this, "handlePaste", pasteEvent => {
      let thisComponent = this;
      retrieveImageFromClipboardAsBlob(pasteEvent, function (imageBlob) {
        if (imageBlob) {
          thisComponent.uploadFile([imageBlob]);
        }
      });
    });

    _defineProperty(this, "uploadFile", files => {
      _.map(files, file => {
        getBase64(file, fileBase64 => {
          this.props.handleFileDropped(file, fileBase64);
        });
      });
    });

    _defineProperty(this, "handleOnDragOver", () => {
      this.setState({
        showFileDropHint: true
      });
    });

    _defineProperty(this, "hideFileDropHint", () => {
      this.setState({
        showFileDropHint: false
      });
    });

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(ReactFileDrop, {
        onDrop: this.uploadFile,
        onFrameDragEnter: this.handleOnDragOver,
        onFrameDrop: this.hideFileDropHint,
        onFrameDragLeave: this.hideFileDropHint
      }, /*#__PURE__*/React.createElement(FileDropHint, {
        show: this.state.showFileDropHint,
        hint: this.props.hint
      }), this.props.children);
    });
  }

  componentDidMount() {
    window.addEventListener("paste", this.handlePaste);
  }

  componentWillUnmount() {
    window.removeEventListener('paste', this.handlePaste);
  }

}

export default FileDrop;